module.exports = __webpack_public_path__ + "img/hansfreitag.8a500736.png";